<template>
    <div class="computerBox">
        <topBox :title="$t('text.MonthDirectRecharge')" />
        <div class="px-[36px] w-full mt-[80px] pb-[70px]">
            <p class="mb-3 text-14 font-semibold text-slate-400 text-center leading-relaxed">
                {{ $t('text.monthDirectRechargeDesc') }}
            </p>

            <div class="rounded-[20px] border bg-white px-[20px] py-[12px] shadow-lg text-center mb-4">
                <div class="text-14 text-slate-400">{{ $t('text.MonthDirectRecharge') }}</div>
                <div class="mt-1 text-m14 font-semibold text-slate-900">
                    ¥{{ formatAmount(amountTotal) }}
                    <span v-if="percentage !== null" class="ml-2 text-slate-400 font-normal">{{ percentage }}%</span>
                </div>
                <div v-if="monthLabel" class="mt-1 text-12 text-slate-400">{{ monthLabel }}</div>
            </div>

            <div v-if="loading" class="py-10 text-center text-sm text-slate-400">
                {{ $t('text.loading') }}
            </div>

            <template v-else>
                <div
                    v-for="item in list"
                    :key="item.member_id"
                    class="record-item"
                >
                    <div class="flex items-center justify-between gap-3">
                        <div class="min-w-0">
                            <div class="text-m14 font-semibold text-slate-900 truncate">{{ item.account }}</div>
                            <div class="mt-1 text-12 text-slate-400">
                                {{ $t('text.estimatedCommission') }}：¥{{ formatAmount(item.commission_amount) }}
                            </div>
                        </div>
                        <div class="shrink-0 text-m14 font-semibold text-green-600">
                            ¥{{ formatAmount(item.recharge_amount) }}
                        </div>
                    </div>
                </div>

                <div v-if="list.length === 0" class="py-10 text-center text-12 text-slate-400">
                    {{ $t('text.noMonthDirectRecharge') }}
                </div>
            </template>
        </div>
        <mainMenu />
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import topBox from '@/components/computer/TopBox.vue'
import mainMenu from '@/components/computer/MainMenu.vue'
import axios from 'axios'
import { layer } from 'vue3-layer'

export default {
    components: {
        topBox,
        mainMenu,
    },
    data() {
        return {
            lang: '',
            loading: true,
            list: [],
            amountTotal: 0,
            percentage: null,
            month: '',
        }
    },
    computed: {
        monthLabel() {
            const m = String(this.month || '')
            if (m.length !== 6) return ''
            return `${m.slice(0, 4)}-${m.slice(4, 6)}`
        },
    },
    mounted() {
        const { locale } = useI18n()
        this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : locale.value
        locale.value = this.lang
        this.fetchList()
    },
    methods: {
        formatAmount(amount) {
            const n = Number(amount)
            if (Number.isNaN(n)) return '0.00'
            return n.toFixed(2)
        },
        fetchList() {
            this.loading = true
            axios.get(
                '/api/m/commission/direct/subordinates',
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang,
                        'token': localStorage.getItem('token'),
                    },
                }
            )
            .then((response) => {
                if (response.data.code === 0) {
                    const data = response.data.data || {}
                    this.list = data.items || []
                    this.amountTotal = data.amount_total || 0
                    this.percentage = data.percentage ?? null
                    this.month = data.month || ''
                } else {
                    if (response.data.code === 911) localStorage.removeItem('isLogin')
                    layer.msg(response.data.msg)
                }
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                this.loading = false
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.computerBox {
    background: url('https://tdkt06.com/img/headbg2x.1c5aca6e.png') 0% 0% / 100% no-repeat;
}

.record-item {
    padding: 14px 16px;
    margin-bottom: 10px;
    border-radius: 16px;
    background: #fff;
    border: 1px solid #e5e7eb;
    box-shadow: 0 4px 6px -4px rgba(0, 0, 0, 0.08);
}
</style>
